import axios from "axios";
import { MEDTHOD } from "../constant/constant";
import { BACKEND_URL } from "../utils/util";

const SystemService = {
  signIn: (reqData) =>
    axios({ method: MEDTHOD.POST, url: `${BACKEND_URL}/login/login_result.php`, data: reqData }),
};

export default SystemService;
